import {Component, OnInit} from '@angular/core';
import {CrudConfig, RequestParams} from '@ngx-ivengi/crud';
import {Observable} from 'rxjs/Observable';
import {Building} from '../building/building.model';
import {EnumerationService} from '../enumeration/enumeration.service';
import {Maintenance} from '../maintenance/maintenance.model';
import {MaintenanceService} from '../maintenance/maintenance.service';
import {Note} from '../maintenance/note/note.model';
import {NoteService} from '../maintenance/note/note.service';
import {Profile} from '../profile/profile.model';
import {ProfileService} from '../profile/profile.service';

@Component({
  selector: 'app-dashboard-employee',
  templateUrl: './dashboard-employee.component.html'
})
export class DashboardEmployeeComponent implements OnInit {

  public profile: Observable<Profile>;
  public actions: string[] = [];
  public maintenanceBlocks: {[key: string]: Maintenance[]} = {'new': [], progress: []};
  public buildingBlocks: {[key: string]: Maintenance[]} = {'new': [], progress: [], archive: []};
  public maintenances: Maintenance[] = [];
  public buildings: Building[] = [];
  public selectedBuilding: Building = null;

  private buildingFilterId: number = this.crudConfig.getFilterId();

  constructor(
    private maintenanceService: MaintenanceService,
    private noteService: NoteService,
    private enumService: EnumerationService,
    private profileService: ProfileService,
    private crudConfig: CrudConfig
  ) {}

  public ngOnInit(): void {
    this.profile = this.profileService.get();

    this.enumService.get('maintenance-action').subscribe((actions: string[]) => {
      this.actions = actions;
    });

    this.maintenanceService.getAllBuildings().subscribe((buildings: Building[]) => {
      this.buildings = buildings;
    });


    this.maintenanceService.getAllActive().subscribe((maintenances: Maintenance[]) => {
      maintenances = maintenances.map((maintenance: Maintenance) => {
        maintenance.visible = (!this.selectedBuilding || !this.selectedBuilding.id || (this.selectedBuilding.id === maintenance.building.id));
        return maintenance;
      });

      maintenances.forEach((maintenance: Maintenance) => {
        if(maintenance.status === 'NEW') {
          this.maintenanceBlocks.new.push(maintenance);
        } else {
          this.maintenanceBlocks.progress.push(maintenance);
        }
      });

    });
  }

  public toggleMaintenance(maintenance: Maintenance) {
    if(maintenance instanceof Maintenance) {
      maintenance.collapse = !maintenance.collapse;
      if(!maintenance.notes) {
        const requestParams = new RequestParams();
        requestParams.pagination.limit = 0;
        requestParams.sorting.addSortParam({
          key: 'createdDate',
          value: 'desc'
        });


        this.noteService.clearRoutePrefix();
        this.noteService.setRoutePrefix(`maintenance/${maintenance.id}`);
        this.noteService.getAll(requestParams).subscribe((notes: Note[]) => {
          maintenance.setNotes(notes);
        });
      }
    }
  }

  public update(maintenance) {
    if(maintenance.noteDraft.isValid()) {
      this.noteService.clearRoutePrefix();
      this.noteService.setRoutePrefix(`maintenance/${maintenance.id}`);

      this.noteService.add(maintenance.noteDraft).subscribe((response: any) => {
        const note = new Note();
        note.fromResponse(response);

        maintenance.addNote(note);

        switch(maintenance.noteDraft.type) {
          case 'UPDATE':
          case 'CALLED':
          case 'MAILED': {
            if(maintenance.status !== 'PROGRESS') {
              maintenance.setStatus('PROGRESS');
              this.maintenanceService.update(maintenance).subscribe();

              for(let i = 0; i <= this.maintenanceBlocks.new.length; i++) {
                if(this.maintenanceBlocks.new[i] === maintenance) {
                  this.maintenanceBlocks.progress.unshift(maintenance);
                  this.maintenanceBlocks.new.splice(i, 1);
                }
              }
            }
            break;
          }

          case 'ARCHIVE':
          case 'REJECT':
          case 'UNANSWERED': {
            if(maintenance.status !== 'ARCHIVE') {
              maintenance.setStatus('ARCHIVE');
              this.maintenanceService.update(maintenance).subscribe();

              for(const key in this.maintenanceBlocks) {
                for(let i = 0; i <= this.maintenanceBlocks[key].length; i++) {
                  if(this.maintenanceBlocks[key][i] === maintenance) {
                    this.maintenanceBlocks[key].splice(i, 1);
                    this.maintenanceService.update(maintenance).subscribe();
                  }
                }
              }

            }
            break;
          }
        }

        maintenance.noteDraft = new Note();
      });
    }
  }

  public onBuildingChange() {
    if(this.selectedBuilding instanceof Building) {
      const requestParams = new RequestParams();
      requestParams
        .addFilterParam({
          id: this.buildingFilterId,
          key: 'building.id',
          operator: 'eq',
          value: <string>this.selectedBuilding.id
        })
        .pagination.limit = 0;

      this.maintenanceService.getAll(requestParams).subscribe((buildingItems) => {

        for(const buildingBlockType in this.buildingBlocks) {
          this.buildingBlocks[buildingBlockType].splice(0, this.buildingBlocks[buildingBlockType].length);
        }

        buildingItems.forEach((maintenance: Maintenance) => {

          switch(maintenance.status) {
            case 'NEW': {
              this.buildingBlocks.new.push(maintenance);
              break;
            }

            case 'PROGRESS': {
              this.buildingBlocks.progress.push(maintenance);
              break;
            }

            case 'ARCHIVE': {
              this.buildingBlocks.archive.push(maintenance);
              break;
            }
          }
        });
      });
    } else {
      this.buildingBlocks = {new: [], progress: [], archive: []};
    }
  }

  public renderMail(maintenance) {
    this.maintenanceService.renderMail(maintenance).subscribe((email) => {
      const params = new URLSearchParams();

      const parameters = [];
      Object.keys(email.headers).forEach((key) => {
        parameters.push(`${key}=${encodeURIComponent(email.headers[key])}`);
      });

      window.location.href = 'mailto:' + email.address + '?' + parameters.join('&');
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/dashboard/dashboard-employee.component.ts